import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faUtensils, faTag } from '@fortawesome/free-solid-svg-icons';
import { useAdmin } from '../../context/AdminContext';
import AdminDetailModal from '../shared/AdminDetailModal';

const AreaDetailsModal = ({ show, onClose, area, users, items }) => {
  const { categories } = useAdmin();

  if (!area) {
    return null;
  }

  const groupedItems = items.reduce((acc, item) => {
    const categoryName = categories.find((category) => category.id === item.categoryId)?.name || 'Kategori bulunamadı';
    if (!acc[categoryName]) {
      acc[categoryName] = [];
    }
    acc[categoryName].push(item);
    return acc;
  }, {});

  return (
    <AdminDetailModal
      show={show}
      onClose={onClose}
      title={area.name}
      subtitle="Alan kapsamı, ekip atamaları ve bağlı ürün özeti"
      icon={faTag}
      summary={(
        <div className="admin-chip-row">
          <span className="admin-chip admin-chip-accent">
            <FontAwesomeIcon icon={faUsers} />
            {users.length} kullanıcı
          </span>
          <span className="admin-chip admin-chip-success">
            <FontAwesomeIcon icon={faUtensils} />
            {items.length} ürün
          </span>
        </div>
      )}
    >
      <div className="admin-detail-grid">
        <div className="admin-detail-card">
          <div className="admin-detail-card-title">Kullanıcılar</div>
          <div className="admin-detail-list">
            {users.length ? users.map((user) => (
              <div key={user.id} className="admin-detail-item">
                <div className="admin-detail-label">{user.role?.name || 'Rol Yok'}</div>
                <div className="admin-detail-value">{user.email}</div>
              </div>
            )) : <div className="admin-muted-note">Bu alana bağlı kullanıcı yok.</div>}
          </div>
        </div>
        <div className="admin-detail-card">
          <div className="admin-detail-card-title">Ürünler</div>
          <div className="admin-detail-list">
            {Object.keys(groupedItems).length ? Object.entries(groupedItems).map(([categoryName, categoryItems]) => (
              <div key={categoryName} className="admin-detail-item">
                <div className="admin-detail-label">{categoryName}</div>
                <div className="admin-detail-value">{categoryItems.map((item) => item.name).join(', ')}</div>
              </div>
            )) : <div className="admin-muted-note">Bu alana bağlı ürün yok.</div>}
          </div>
        </div>
      </div>
    </AdminDetailModal>
  );
};

export default AreaDetailsModal;
